// @react
import React, { Dispatch, ReactElement, SetStateAction } from 'react'
// @graphQL
import { PublicUserConnectionType } from 'lib/graphql/graphqlTypes'
import PublicUsersList from 'modules/common/components/PublicUserList'

/**
 * 5.0.6.1 Profile - Network - Followers / Followed
 * i.e. users that are following the current user
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A5776
 *
 *  fields:
 *  user  lastName
 *  user  firstName
 *  user  staff
 *  user  imageUrl
 *  user  jobTitle
 */

type PropsType = {
  setCount: Dispatch<SetStateAction<number>>
}

const Followers = (props: PropsType): ReactElement => {
  return (
    <PublicUsersList
      title="Followed"
      setCount={props.setCount}
      queryInput={{
        filters: {
          type: PublicUserConnectionType.FOLLOWED,
        },
      }}
    />
  )
}

export default Followers
